import { render, staticRenderFns } from "./SamTabs.vue?vue&type=template&id=36260e9e&scoped=true&shadow"
import script from "./SamTabs.vue?vue&type=script&lang=js&shadow"
export * from "./SamTabs.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamTabs.vue?vue&type=style&index=0&id=36260e9e&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "36260e9e",
  null
  ,true
)

export default component.exports